import { field_background_theme, field_color_theme } from 'framework/field/constants';

import { OPTION_HEIGHT, OPTION_PADDING, OPTIONS_OFFSET } from '../../constants';
import { OptionsTheme } from '../Options/types';
import { colors, font } from '../theme/constants/colors';
import { font_theme } from '../theme/constants/font';

export const options_theme: Pick<OptionsTheme, 'general' | 'settings'> = {
  general: {
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_normal,
    border_radius: '4px',
  },
  settings: {
    padding: OPTION_PADDING,
    option_height: OPTION_HEIGHT,
    option_offset: OPTIONS_OFFSET,
  },
};

export const options_light_theme: OptionsTheme = {
  general: options_theme.general,
  settings: options_theme.settings,
  background: {
    normal: colors.light[1],
    hover: colors.light[2],
    focus: colors.light[4],
    active: colors.blue[1],
  },
  color: {
    normal: font.dark.normal,
    hover: colors.blue[6],
    focus: font.dark.normal,
    active: colors.blue[6],
  },
};

export const options_dark_theme: OptionsTheme = {
  general: options_theme.general,
  settings: options_theme.settings,
  background: {
    normal: field_background_theme.normal,
    hover: colors.dark[9],
    focus: colors.dark[7],
    active: colors.dark[9],
  },
  color: {
    normal: field_color_theme.normal,
    hover: field_color_theme.hover,
    focus: colors.purple[9],
    active: field_color_theme.active,
  },
};
